import { getApiErrorMessage } from '@frontend-platform/api-client';
import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

// The error toast lives on the mutation cache, not on
// `defaultOptions.mutations.onError`: TanStack *replaces* that default as soon
// as a `useMutation` passes its own `onError`, so a hook adding one would
// silently drop the global toast. The cache handler always runs. Matches
// integration-builder's query client.
//
// A cache belongs to exactly one client, so this is a factory — tests build
// their own to render components against the real error handling.
export function createMutationCache(): MutationCache {
  return new MutationCache({
    onError: (error) => {
      toast.error(getApiErrorMessage(error as Error));
    },
  });
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
  mutationCache: createMutationCache(),
});
